interface Props {
  title: string
  children: React.ReactNode
}

export default function LegalLayout({ title, children }: Props) {
  return (
    <div className="py-14 lg:py-20">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <h1 className="text-3xl lg:text-4xl font-extrabold text-navy-700 tracking-tight">{title}</h1>
        <div className="mt-8 prose prose-navy max-w-none text-navy-600 space-y-5 leading-relaxed text-[15px]">
          {children}
        </div>
      </div>
    </div>
  )
}
